module.exports = __webpack_public_path__ + "img/scatter_freespin.ac9cad90.png";